// eslint-disable-next-line
import React, { CSSProperties } from 'react';

import '../css/search.css'

import Container from '../basicComponents/Container';
import Text from '../basicComponents/Text';
import TextClick from '../basicComponents/TextClick';
import { AppContext } from '../AppContext';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import InputDate from '../basicComponents/InputDate';
import InputText from '../basicComponents/InputText';
import ListSelect from '../appComponents/ListSelect';
import Button from '../basicComponents/Button';
import LogRecord, { LogRecordSearchRequest, LogRecordSearchResponse, LogRecordExportRequest, LogRecordExportResponse } from '../data/LogRecord';
import Icon from '../basicComponents/Icon';
import InputTime from '../basicComponents/InputTime';
import Modal from '../basicComponents/Modal';
import Link from '../basicComponents/Link';
import { SearchParameter } from '../data/Search';
import { SortConfig } from '../data/Sort';
import { deepCopy } from '../util/DeepCopy';

export interface SearchPageProps extends RouteComponentProps {

    searchParameter: SearchParameter;
    records: LogRecord[] | undefined;
    curRecord: LogRecord | undefined;

    setSearchParameter: (searchParameter: SearchParameter) => void;
    setRecords: (records: LogRecord[] | undefined) => void;
    setCurRecord: (curRecord: LogRecord | undefined) => void;

    searchRange: string;
    searchLimit: number;

}

export interface SearchPageState {
    showModal: boolean;
    message: JSX.Element | null;
    showMessage: boolean;

    sortConfig: SortConfig | undefined;
}

class SearchPageComponent extends React.Component<SearchPageProps, SearchPageState> {

    // app context
    static contextType = AppContext;
    context!: React.ContextType<typeof AppContext>;

    // variable contains input element to set focus
	private telInput: HTMLInputElement | null = null;

    constructor(props: SearchPageProps) {

        // call parent
        super(props);

        // set state
        this.state = {
            showModal: false,
            message: null,
            showMessage: false,
            sortConfig: undefined,
        };

    }

    public render = (): JSX.Element => {

        const modal = this.state.showModal ? (
            <Modal>
                <div className="modal">
                    <img className='modal-loader' src={`${process.env.PUBLIC_URL}/gif/sym-loader.gif`} alt='Just a second...' />
                </div>
            </Modal>
        ) : null;

        // count active record fields
        let recordFields = 0;
        this.props.searchParameter.searchOptions
            .filter( option => option.databaseName.startsWith("log") === false )
            .filter( option => option.searchActive )
            .forEach( () => recordFields++)

        // count active log fields
        let logFields = 0;
        this.props.searchParameter.searchOptions
            .filter( option => option.databaseName.startsWith("log") )
            .filter( option => option.searchActive )
            .forEach( () => logFields++)

        return (
            <React.Fragment>
                
                <Container className='search-parameter'>

                    <Container className='search-listSelect'>
                        <ListSelect allEntries={this.props.searchParameter.serverEntries} selectedEntries={this.props.searchParameter.selectedServer} handleSelectChange={this.handleSelectChange} />
                    </Container>

                    <Container className='search-block-date'>
                        <Text className='search-label'>Date From</Text>
                        <InputDate className='search-date-time' name='DateFrom' value={this.props.searchParameter.queryDateFrom} onChange={this.handleChange} />
                        <InputTime className='search-date-time' name='TimeFrom' value={this.props.searchParameter.queryTimeFrom} onChange={this.handleChange} />
                        <Text className='search-label'>Date To</Text>
                        <InputDate className='search-date-time' name='DateTo' value={this.props.searchParameter.queryDateTo} onChange={this.handleChange} />
                        <InputTime className='search-date-time' name='TimeTo' value={this.props.searchParameter.queryTimeTo} onChange={this.handleChange} />
                    </Container>

                    {recordFields > 0 ? 
                        <Container className='search-block'>
                            {this.props.searchParameter.searchOptions
                                .filter( option => option.databaseName.startsWith("log") === false )
                                .filter( option => option.searchActive )
                                .map( (option, idx) => {
                                    return (
                                        <React.Fragment key={idx}>
                                            <Text className='search-label'>{option.displayName}</Text>
                                            {option.databaseName === 'callerId' ?
                                                <InputText className='search-input-text' name={option.databaseName} value={option.value} onChange={this.handleChange} onKeyPress={this.handleKeyPress} refFunc={ (input): void => { this.telInput = input } }/>
                                            :
                                                <InputText className='search-input-text' name={option.databaseName} value={option.value} onChange={this.handleChange} onKeyPress={this.handleKeyPress} />
                                            }
                                        </React.Fragment>
                                    );
                                })}
                        </Container>
                    :
                    null
                    }

                    {logFields > 0 ? 
                        <Container className='search-block'>
                            {this.props.searchParameter.searchOptions
                                .filter( option => option.databaseName.startsWith("log") )
                                .filter( option => option.searchActive )
                                .map( (option, idx) => {
                                    return (
                                        <React.Fragment key={idx}>
                                            <Text className='search-label'>{option.displayName}</Text>
                                            <InputText className='search-input-text' name={option.databaseName} value={option.value} onChange={this.handleChange} onKeyPress={this.handleKeyPress} />
                                        </React.Fragment>
                                    );
                                })}
                        </Container>
                    :
                    null
                    }

                    <Container className='search-block-button'>
                        <Button className='search-button' name='search' value='search' onClick={this.handleClick} />
                        {this.props.records !== undefined ? <Text className='search-count-records'>{this.props.records.length + ' record' + (this.props.records.length !== 1 ? 's' : '')}</Text> : null}
                    </Container>
                    <Button disabled={!this.props.records} className='export-button' name='export' value='export' onClick={this.handleClick} />

                </Container>

                <Container className='search-divider' />

                <Container className='search-result'>
                    <div className='search-result-list' style={this.buildSearchListCSS()}>

                        {this.props.records  && this.props.records.length > 0 ? 
                            <React.Fragment>
                                {this.props.searchParameter.searchOptions
                                    .filter( option => option.viewActive )
                                    .map( (option, idx) => <TextClick name={option.databaseName} key={idx} className={this.getHeaderClassName(option.databaseName)} onClick={() => this.requestSort(option.databaseName)}>{option.displayName}</TextClick>)
                                }
                                <Text className='search-result-header-value'>Dlg</Text>
                                <Text className='search-result-header-value'>Hty</Text>
                                <Text className='search-result-header-value'>Log</Text>
                            </React.Fragment>
                            :
                            null
                        }

                        {this.props.records ?
                            this.props.records
                                .filter(record => {
                                    let valid = true;
                                    this.props.searchParameter.filterMap.forEach( (value, key): void => {
                                        if (record[key] !== undefined && record[key]?.toString() !== value) {
                                            valid = false;
                                        }
                                    })
                                    return valid;
                                })
                                .map((record, idx) => {

                                    record.startDate = record.startDate.replace("T", " ");

                                    let cN = idx % 2 === 0 ? 'search-result-value-even' : 'search-result-value-odd';
                                    if (this.props.curRecord !== undefined) {
                                        if (this.props.curRecord.sessionId === record.sessionId) {
                                            cN = cN + ' search-result-value-bold';
                                        }
                                    }

                                    return (
                                        <React.Fragment key={idx}>
                                            {this.props.searchParameter.searchOptions
                                                .filter( option => option.viewActive )
                                                .map( (option, idxlog) => <TextClick key={idxlog} className={cN} name={`${option.databaseName}_${record[option.databaseName]}`} onClick={this.handleFilterClick}>{record[option.databaseName]}</TextClick>)
                                            }
                                            <Text className={cN}><Icon className='' name={'DLG_' + record.sessionId} url={`${process.env.PUBLIC_URL}/image/media-seek-forward.svg`} onClick={this.handleSessionClick} /></Text>
                                            <Text className={cN}><Icon className='' name={'HTY_' + record.sessionId} url={`${process.env.PUBLIC_URL}/image/media-seek-forward.svg`} onClick={this.handleSessionClick} /></Text>
                                            <Text className={cN}><Icon className='' name={'LOG_' + record.sessionId} url={`${process.env.PUBLIC_URL}/image/media-seek-forward.svg`} onClick={this.handleSessionClick} /></Text>
                                        </React.Fragment>
                                    );

                                })
                            :
                            null
                        }

                    </div>
                </Container>
                {modal}
                {this.state.message}
            </React.Fragment>
        );

    }

    public componentDidMount = (): void => {

        // set focus to telephone
        if (this.telInput) {
            this.telInput.focus();
        }

        // check selected entries
        const setting = this.context.user.getUserSetting('SymQuery', 'searchHosts');
        if (setting != null) {
            const searchHosts = JSON.parse(setting) as string[];
            const searchParameter = { ...this.props.searchParameter };
            searchParameter.selectedServer = searchHosts;
            this.props.setSearchParameter(searchParameter);
        }

    }

    private handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {

        const target = event.currentTarget;
        const name = target.dataset.name;
        const value = target.value;

        // check static fields
        switch (name) {

            // check static fields
            case 'DateFrom':  { const searchParameter = { ...this.props.searchParameter }; searchParameter.queryDateFrom = value; this.props.setSearchParameter(searchParameter); } break;
            case 'DateTo':    { const searchParameter = { ...this.props.searchParameter }; searchParameter.queryDateTo   = value; this.props.setSearchParameter(searchParameter); } break;
            case 'TimeFrom':  { const searchParameter = { ...this.props.searchParameter }; searchParameter.queryTimeFrom = value; this.props.setSearchParameter(searchParameter); } break;
            case 'TimeTo':    { const searchParameter = { ...this.props.searchParameter }; searchParameter.queryTimeTo   = value; this.props.setSearchParameter(searchParameter); } break;

            // check dynamic fields
            default:
                {
                    const searchOptions = [ ...this.props.searchParameter.searchOptions ];
                    const searchOption = searchOptions.find( option => option.databaseName === name );
                    if (searchOption) {
                        searchOption.value = value;
                        const searchParameter = { ...this.props.searchParameter };
                        searchParameter.searchOptions = searchOptions;
                        this.props.setSearchParameter(searchParameter);
                    }
                }
                break;

        }

    }

    private handleSelectChange = (selectedEntries: string[]): void => {
        this.context.user.setUserSetting('SymQuery', 'searchHosts', JSON.stringify(selectedEntries));
        const searchParameter = { ...this.props.searchParameter };
        searchParameter.selectedServer = selectedEntries;
        this.props.setSearchParameter(searchParameter);
    }

    private handleClick = (event: React.MouseEvent<HTMLInputElement, MouseEvent>): void => {

        const target = event.currentTarget;
        const name = target.dataset.name;

        if (name === 'search') {
            this.searchRecords();
        }
        else if (name === 'export') {
            this.exportRecords();
        }

    }

    private handleFilterClick = (event: React.MouseEvent<HTMLSpanElement>): void => {

        const target = event.currentTarget;
        const name = target.dataset.name;

        if (name) {

            // get key/value of filter
            const idx = name.indexOf('_');
            const key = name.substring(0, idx);
            const value = name.substring(idx + 1);

            // copy search parameter
            const searchParameter = { ...this.props.searchParameter };

            // find entry
            if (searchParameter.filterMap.has(key)) {

                // remove key/value
                const newMap = new Map<string, string>();
                searchParameter.filterMap.forEach( (value, key) => newMap.set(key, value));
                newMap.delete(key);
                searchParameter.filterMap = newMap;

            }
            else {

                // add key/value
                const newMap = new Map<string, string>();
                searchParameter.filterMap.forEach( (value, key) => newMap.set(key, value));
                newMap.set(key, value);
                searchParameter.filterMap = newMap;

            }

            // set search parameter
            this.props.setSearchParameter(searchParameter);

        }

    }

    private getHeaderClassName = (databaseName: string): string => {
        let className = this.props.searchParameter.filterMap.has(databaseName) ? 'search-result-header-value-filter' : 'search-result-header-value';
        if (this.state.sortConfig && this.state.sortConfig.key === databaseName) {
            className += this.state.sortConfig.direction === 'ascending' ? ' ascending' : ' descending';
        }

        return className;
    }

    private requestSort = (key: string) => {

        // set/change current sortConfig
        let sortConfig: SortConfig;

        if (this.state.sortConfig === undefined) {
            sortConfig = { key: key, direction: 'ascending' };
        }
        else {
            // change sort order if column was clicked before
            if (this.state.sortConfig.key === key) {
                sortConfig = {
                    key: this.state.sortConfig.key,
                    direction: this.state.sortConfig.direction === 'ascending' ? 'descending' : 'ascending',
                }
            }   
            else {
                sortConfig = { key: key, direction: 'ascending' };
            } 
        }

        // sort records
        const records = deepCopy(this.props.records);
        if (records) {
            records.sort((a, b) => {

                const valA = a[sortConfig.key];
                const valB = b[sortConfig.key];

                if (valA !== undefined && valB !== undefined) {
                    if (valA < valB) {
                        return sortConfig.direction === 'ascending' ? -1 : 1;
                    }
                    if (valA > valB) {
                        return sortConfig.direction === 'ascending' ? 1 : -1;
                    }
                }
                else {
                    return 0;
                }

                return 0;

            });
        }

        this.setState({ sortConfig });

        this.context.app.setState({
            records: records
        });
    }

    private handleSessionClick = (event: React.MouseEvent<HTMLSpanElement>): void => {

        const target = event.currentTarget;
        const name = target.dataset.name;

        console.log('clicked on ' + name);

        if (name && this.props.records) {

            // Dialog
            if (name.startsWith("DLG_")) {

                const sessionId = name.substring("DLG_".length);

                // find entry
                let record = this.props.records[0];
                for (let x = 0; x < this.props.records.length; x++) {
                    if (this.props.records[x].sessionId === sessionId) {
                        record = this.props.records[x];
                        break;
                    }
                }

                this.props.setCurRecord(record)
                this.context.app.addSidebar({ name: 'DLG ' + record.sessionId, link: '/dialog/' + record.sessionId });
                this.props.history.push('/dialog/' + record.sessionId);

            }

            // LogHistory
            if (name.startsWith("HTY_")) {

                const sessionId = name.substring("HTY_".length);

                // find entry
                let record = this.props.records[0];
                for (let x = 0; x < this.props.records.length; x++) {
                    if (this.props.records[x].sessionId === sessionId) {
                        record = this.props.records[x];
                        break;
                    }
                }

                this.props.setCurRecord(record)
                this.context.app.addSidebar({ name: 'HTY ' + record.sessionId, link: '/logHistory/' + record.sessionId });
                this.props.history.push('/logHistory/' + record.sessionId);

            }

            // Logging
            if (name.startsWith("LOG_")) {

                const sessionId = name.substring("LOG_".length);

                // find entry
                let record = this.props.records[0];
                for (let x = 0; x < this.props.records.length; x++) {
                    if (this.props.records[x].sessionId === sessionId) {
                        record = this.props.records[x];
                        break;
                    }
                }

                this.props.setCurRecord(record)
                this.context.app.addSidebar({ name: 'LOG ' + record.sessionId, link: '/logging/' + record.sessionId });
                this.props.history.push('/logging/' + record.sessionId);

            }

        }

    }

    private handleMessageClick = (event: React.MouseEvent<HTMLInputElement, MouseEvent>): void => {
        const target = event.currentTarget;
        const name = target.dataset.name;

        console.log('clicked on ' + name);
        this.setState({ message: null });
    }

    private handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>): void => {

		if (event.key === "Enter") {
            this.searchRecords();
        }

    }

    private searchRecords = (): void => {

        this.setState({ showModal: true });

        // build request
        let request: LogRecordSearchRequest = {
            serverList: this.props.searchParameter.selectedServer,
            dateFrom: this.props.searchParameter.queryDateFrom,
            dateTo: this.props.searchParameter.queryDateTo,
            timeFrom: this.props.searchParameter.queryTimeFrom,
            timeTo: this.props.searchParameter.queryTimeTo,
            limit: this.props.searchLimit,
        }

        // add other fields to request
        this.props.searchParameter.searchOptions
            .filter( option => option.searchActive )
            .filter( option => option.value.length > 0)
            .forEach( option => request = { ...request, [option.databaseName]: option.value } );

        // send request
        this.context.restAppService.request_post('logRecord/search', this.context.user.getToken(), 'text/json', JSON.stringify(request),
            (data): void => {

                const response = JSON.parse(data) as LogRecordSearchResponse;

                // set duration (in seconds)
                response.results.forEach( record => record.duration = ((record.stopTime - record.startTime) / 1000).toFixed(0));
                this.props.setRecords(response.results);

                // reset filter parameter
                const searchParameter = { ...this.props.searchParameter };
                searchParameter.filterMap = new Map<string, string>();
                this.props.setSearchParameter(searchParameter);

                // set modal to false
                this.setState({ showModal: false });

            },
            (status, text): void => {

                console.log("search failed " + status + " " + text);
                this.props.setRecords([]);
                const message: JSX.Element =
                    <Modal>
                        <div className="modal-message">
                            <div className="modal-message-box">
                                <div className='modal-message-box-left'>
                                    <Icon className='modal-message-box-icon' url={`${process.env.PUBLIC_URL}/image/help-hint.svg`} />
                                </div>
                                <div className='modal-message-box-right'>
                                    <div className='modal-message-box-top'>
                                        <Text className=''>{text}</Text>
                                    </div>
                                    <div className='modal-message-box-bottom'>
                                        <Button className='' name='message' value='OK' onClick={this.handleMessageClick} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal>

                this.setState({ showModal: false, message: message });

            }
        );

    }

    private exportRecords = (): void => {

        this.setState({ showModal: true });

        // build request
        const sessionIds: string[] = [];
        if (this.props.records) {
            this.props.records
            .forEach( record => sessionIds.push(record.sessionId));
        }
        const request: LogRecordExportRequest = {
            sessionIds: sessionIds
        }
        // send request
        this.context.restAppService.request_post('logRecord/request/' + this.props.searchParameter.selectedServer, this.context.user.getToken(), 'text/json', JSON.stringify(request),
            (data): void => {

                const response = JSON.parse(data) as LogRecordExportResponse;
                
                const message: JSX.Element =
                    <Modal>
                        <div className="modal-message">
                            <div className="modal-message-box">
                                <div className='modal-message-box-left'>
                                    <Icon className='modal-message-box-icon' url={`${process.env.PUBLIC_URL}/image/help-hint.svg`} />
                                </div>
                                <div className='modal-message-box-right'>
                                    <div className='modal-message-box-top'>
                                        <Link reference={`/SymQuery/download/${response.filename}`}>Download CSV</Link>
                                    </div>
                                    <div className='modal-message-box-bottom'>
                                        <Button className='' name='message' value='OK' onClick={this.handleMessageClick} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal>

                // set modal to false
                this.setState({ showModal: false, message: message });

            },
            (status, text): void => {

                console.log("export failed " + status + " " + text);
                const message: JSX.Element =
                    <Modal>
                        <div className="modal-message">
                            <div className="modal-message-box">
                                <div className='modal-message-box-left'>
                                    <Icon className='modal-message-box-icon' url={`${process.env.PUBLIC_URL}/image/help-hint.svg`} />
                                </div>
                                <div className='modal-message-box-right'>
                                    <div className='modal-message-box-top'>
                                        <Text className=''>{text}</Text>
                                    </div>
                                    <div className='modal-message-box-bottom'>
                                        <Button className='' name='message' value='OK' onClick={this.handleMessageClick} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal>

                this.setState({ showModal: false, message: message });

            }
        );

    }

    private buildSearchListCSS = (): CSSProperties => {

        // count active log fields
        let logFields = 0;
        this.props.searchParameter.searchOptions
            .filter( option => option.searchActive )
            .forEach( () => logFields++)

        // build css definition for grid layout
        let css = '';
        this.props.searchParameter.searchOptions
            .filter( option => option.viewActive )
            .forEach( option => {
                switch (option.databaseName) {
                    case 'startDate': css = css + ' minmax(150px, max-content)'; break;
                    case 'sessionId': css = css + ' minmax(120px, max-content)'; break;
                    case 'duration': css = css + ' minmax(30px, max-content)'; break;
                    case 'client': css = css + ' minmax(100px, max-content)'; break;
                    case 'callerId': css = css + ' minmax(120px, max-content)'; break;
                    case 'cdpn': css = css + ' minmax(70px, max-content)'; break;
                    case 'configName': css = css + ' minmax(50px, max-content)'; break;
                    case 'description': css = css + ' minmax(40px, max-content)'; break;
                    case 'uniqueId': css = css + ' minmax(150px, max-content)'; break;
                    case 'step': css = css + ' minmax(40px, max-content)'; break;
                    case 'promptType': css = css + ' minmax(50px, max-content)'; break;
                    case 'promptTitle': css = css + ' minmax(50px, max-content)'; break;
                    case 'log1': css = css + ' minmax(50px, max-content)'; break;
                    case 'log2': css = css + ' minmax(50px, max-content)'; break;
                    case 'log3': css = css + ' minmax(50px, max-content)'; break;
                    case 'log4': css = css + ' minmax(50px, max-content)'; break;
                    case 'log5': css = css + ' minmax(50px, max-content)'; break;
                    case 'log6': css = css + ' minmax(50px, max-content)'; break;
                    case 'log7': css = css + ' minmax(50px, max-content)'; break;
                    case 'log8': css = css + ' minmax(50px, max-content)'; break;
                    case 'log9': css = css + ' minmax(50px, max-content)'; break;
                    case 'error': css = css + ' minmax(50px, max-content)'; break;
                    case 'status': css = css + ' minmax(50px, max-content)'; break;
                    case 'score': css = css + ' minmax(50px, max-content)'; break;
                    default: css = css + ' minmax(50px, max-content)'; break;
                }

            });      

        // add colums for icons
        css = css + ' minmax(40px, max-content)';
        css = css + ' minmax(40px, max-content)';
        css = css + ' minmax(40px, max-content)';

        return {
            gridTemplateColumns: css
        };

    }

}

const SearchPage = withRouter(SearchPageComponent);
export default SearchPage;
